export default "__VITE_ASSET__BY6WmCkp__"